module.exports = __webpack_public_path__ + "static/media/a8.0232b07.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dengyunze/a8.mp3
// module id = 9Cos
// module chunks = 0